import React from 'react';

const AdminPortalIcon = () => (
  React.createElement('svg', {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24"   ,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",}
  
    , React.createElement('path', {
      'fill-rule': "evenodd",
      'clip-rule': "evenodd",
      d: "M4 2C2.89543 2 2 2.89543 2 4V20C2 21.1046 2.89543 22 4 22H20C21.1046 22 22 21.1046 22 20V4C22 2.89543 21.1046 2 20 2H4ZM4.46973 16.364H6.447L7.0944 14.3739H10.2455L10.8916 16.364H12.8689L9.86035 7.63672H7.48251L4.46973 16.364ZM9.77781 12.9336L8.70552 9.63104H8.63734L7.56296 12.9336H9.77781ZM12.9593 7.63672V16.364H14.8045V13.5344H16.3556C17.0261 13.5344 17.5971 13.4109 18.0687 13.1637C18.5431 12.9165 18.9053 12.5714 19.1553 12.1282C19.4053 11.685 19.5303 11.1737 19.5303 10.5941C19.5303 10.0146 19.4067 9.5032 19.1596 9.06001C18.9153 8.61399 18.5602 8.26598 18.0942 8.01598C17.6283 7.76314 17.0644 7.63672 16.4025 7.63672H12.9593ZM14.8045 12.0558H16.0573C16.4124 12.0558 16.705 11.9947 16.9352 11.8725C17.1681 11.7475 17.3414 11.5756 17.455 11.3569C17.5715 11.1353 17.6298 10.881 17.6298 10.5941C17.6298 10.3043 17.5715 10.0515 17.455 9.83558C17.3414 9.61683 17.1681 9.4478 16.9352 9.32848C16.7022 9.20632 16.4067 9.14524 16.0488 9.14524H14.8045V12.0558Z"                                                                                           ,
      fill: "#0B6CFF",}
    )
  )
);

export default AdminPortalIcon;
